const KEY = "afanasiev_access";
const PHONE_KEY = "afanasiev_phone";
const DEV_KEY = "afanasiev_device";

const getCloudStorage = () => {
  try {
    return window.Telegram?.WebApp?.CloudStorage || null;
  } catch {
    return null;
  }
};

export const getAccess = () =>
  new Promise((resolve) => {
    try {
      if (localStorage.getItem(KEY) === "1") {
        resolve(true);
        return;
      }
    } catch {}
    const cloud = getCloudStorage();
    if (!cloud) {
      resolve(false);
      return;
    }
    let settled = false;
    const done = (val) => {
      if (!settled) {
        settled = true;
        resolve(val);
      }
    };
    try {
      cloud.getItem(KEY, (err, val) => done(!err && val === "1"));
    } catch {
      done(false);
    }
    setTimeout(() => done(false), 2500);
  });

export const grantAccess = (phone) => {
  try {
    localStorage.setItem(KEY, "1");
    if (phone) localStorage.setItem(PHONE_KEY, phone.replace(/\D/g, ""));
  } catch {}
  try {
    const cloud = getCloudStorage();
    if (cloud) cloud.setItem(KEY, "1", () => {});
  } catch {}
};

export const getPhone = () => {
  try {
    return localStorage.getItem(PHONE_KEY) || "";
  } catch {
    return "";
  }
};

export const getClientKey = () => {
  try {
    const tgUser = window.Telegram?.WebApp?.initDataUnsafe?.user;
    if (tgUser?.id) return `tg_${tgUser.id}`;
  } catch {}
  try {
    const phone = localStorage.getItem(PHONE_KEY);
    if (phone) return `ph_${phone}`;
    let dev = localStorage.getItem(DEV_KEY);
    if (!dev) {
      dev = typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(DEV_KEY, dev);
    }
    return `dev_${dev}`;
  } catch {
    return "anon";
  }
};
